import React from "react";
import { packClasses } from "Utils";
import {
    XCircleIcon,
    CheckCircleIcon,
    InformationCircleIcon,
    ExclamationCircleIcon,
} from "@heroicons/react/solid";

export default function AlertBox(props) {
    const variant = props.variant || "info";
    const variants = {
        info: {
            icon: (
                <InformationCircleIcon
                    className="text-gray h-5 w-5"
                    aria-hidden="true"
                />
            ),
            bgColor: "bg-gray-50",
            textColor: "text-gray-800",
        },
        success: {
            icon: (
                <CheckCircleIcon
                    className="text-green h-5 w-5"
                    aria-hidden="true"
                />
            ),
            bgColor: "bg-green-50",
            textColor: "text-green-800",
        },
        warning: {
            icon: (
                <XCircleIcon
                    className="h-5 w-5 text-red-400"
                    aria-hidden="true"
                />
            ),
            bgColor: "bg-red-50",
            textColor: "text-red-800",
        },
        danger: {
            icon: (
                <ExclamationCircleIcon
                    className="text-yellow h-5 w-5"
                    aria-hidden="true"
                />
            ),
            bgColor: "bg-yellow-50",
            textColor: "text-yellow-800",
        },
    };

    return (
        <div
            className={packClasses(
                variants[variant].bgColor,
                variants[variant].textColor,
                "rounded-md p-4"
            )}
        >
            <div className="flex">
                <div className="flex-shrink-0">{variants[variant].icon}</div>
                <div className="ml-3">{props.children}</div>
            </div>
        </div>
    );
}
